import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { Outlet } from 'react-router-dom';
import Header from '../Header/Header';
import Sidebar from '../Sidebar/Sidebar';
import { selectSidebarPinned } from '../../utils/appSlice';
import { useIsMobile } from '../../hooks/useMediaQuery';
import { getUserDetails } from '../../utils/authUtils';

const COLLAPSE_WIDTH = 68;
const EXPAND_WIDTH = 240;

const BeagleChat = () => {
  const userDetails = useMemo(() => getUserDetails(), []);
  const pinned = useSelector(selectSidebarPinned);
  const isMobile = useIsMobile();

  const contentMarginLeft = isMobile ? 0 : (pinned ? EXPAND_WIDTH : COLLAPSE_WIDTH);

  return (
    <div className="flex h-viewport bg-[var(--bg-primary)]">
      <Sidebar />
      <div
        className="flex-1 flex flex-col min-w-0 transition-all duration-300"
        style={{ marginLeft: contentMarginLeft }}
      >
        <Header userDetails={userDetails} />
        <main className="flex-1 overflow-hidden">
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default BeagleChat;
